

import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

// Add ACH Provider
const addachprovider = ({
  immediate_destination,
  immediate_destination_name,
  immediate_origin,
  immediate_origin_name,
  company_identification,
  standard_entry_class_code,
  originating_bank_fid,
  originator_tax_id,
  ach_operator_name,
  destination,
  destination_name,
  service_class_code
}) => {
  return axios.post(
    API + "company/achproviders/create/",
    {
      immediate_destination,
      immediate_destination_name,
      immediate_origin,
      immediate_origin_name,
      company_identification,
      standard_entry_class_code,
      originating_bank_fid,
      originator_tax_id,
      ach_operator_name,
      destination,
      destination_name,
      service_class_code
    },
    { headers: authHeader() }
  );
};

// Edit ACH Provider
const editachprovider = (
  id,
  {
    immediate_destination,
    immediate_destination_name,
    immediate_origin,
    immediate_origin_name,
    company_identification,
    standard_entry_class_code,
    originating_bank_fid,
    originator_tax_id,
    ach_operator_name,
    destination,
    destination_name,
    service_class_code
  }
) => {
  return axios.post(
    API + `company/achproviders/${id}/update/`,
    {
      immediate_destination,
      immediate_destination_name,
      immediate_origin,
      immediate_origin_name,
      company_identification,
      standard_entry_class_code,
      originating_bank_fid,
      originator_tax_id,
      ach_operator_name,
      destination,
      destination_name,
      service_class_code
    },
    { headers: authHeader() }
  );
};

// Get single ACH Provider (fixed function syntax)
const getACHprovider = (id) => {
  return fetch(`${API}company/achproviders/${id}/`, {
    method: "GET",
    headers: authHeader(),
    cache: "no-store", // disables browser cache!
  }).then((response) => {
    if (!response.ok) throw new Error("Failed to fetch");
    return response.json();
  });
};

// View all ACH Providers
const viewACHprovider = () => {
  return axios.get(API + "company/achproviders/", { headers: authHeader() });
};

const ACHproviderService = {
  addachprovider,
  editachprovider,
  getACHprovider,
  viewACHprovider,
};

export default ACHproviderService;